import { Navigate, useNavigate, useRoutes } from "react-router-dom";

// layouts
import DashboardLayout from "./layouts/dashboard";
import LogoOnlyLayout from "./layouts/LogoOnlyLayout";
//
import Login from "./pages/Login";
import DashboardApp from "./pages/DashboardApp";
import User from "./pages/User";
import NotFound from "./pages/Page404";
import Lead from "./pages/lead";
import InquiryForm from "./pages/InquiryForm";
import LeadInquiryForm from "./pages/LeadInquiryForm";
import LeadRejectReason from "./pages/LeadRejectReason";
import Subadmin from "./pages/Subadmin";
import TrainingAndWebinar from "./pages/TrainingAndWebinar";
import Notification from "./pages/Notification";
import Poll from "./pages/Poll";
import DescriptionEdit from "./pages/DescriptionEdit";
import Member from "./pages/Member";
import MembershipFlow from "./pages/MembershipFlow";
import Magazine from "./pages/Magazine";
import MemberDeactivateReason from "./pages/MemberDeactivateReason";
import WelcomeKit from "./pages/WelcomeKit";
import { Suggestion } from "./pages/Suggestion";
import CancelMembershipSubject from "./pages/CancelMembershipSubject";
import CancelMembershipRequest from "./pages/CancelMembershipRequest";
import LvbSessionPodcast from "./pages/LvbSessionPodcast";
import Greeting from "./pages/Greeting";
import HowToUseApplicationView from "./pages/HowToUseApplicationView";
import AskReasons from "./pages/AskReasons";
import Asks from "./pages/Asks";
import InvoiceSetting from "./pages/InvoiceSetting";
import DownloadInvoice from "./pages/DownloadInvoice";
import Country from "./pages/Country";
import State from "./pages/State";
import City from "./pages/City";
import Promocode from "./pages/Promocode";
import PromocodeMemberList from "./pages/PromocodeMemberList";
import ReferralWithdrawalRequests from "./pages/ReferralWithdrawalRequests";
import ReferralReportList from "./pages/ReferralReportList";
import ReferralReportDetail from "./pages/ReferralReportDetail";

// ----------------------------------------------------------------------
export function AuthRouter() {
  return useRoutes([
    {
      path: "/*",
      element: <LogoOnlyLayout />,
      children: [
        { path: "login", element: <Login /> },
        { path: "*", element: <Login /> },
        { path: "primeinquiry-form", element: <InquiryForm /> },
        { path: "prime-location-inquiry-form", element: <LeadInquiryForm /> }
      ]
    }
  ]);
}
export function Router() {
  let loginUser = JSON.parse(localStorage.getItem("userData"));
  return useRoutes([
    {
      path: "/*",
      element: <LogoOnlyLayout />,
      children: [
        { path: "primeinquiry-form", element: <InquiryForm /> },
        { path: "prime-location-inquiry-form", element: <LeadInquiryForm /> }
      ]
    },
    {
      path: "/*",
      element: <DashboardLayout />,
      children:
        // Admin Routes
        loginUser?.u_type == 3
          ? [
              { path: "*", element: <DashboardApp /> },
              {
                path: "dashboard",
                exact: true,
                strict: true,
                element: <DashboardApp />
              },
              { path: "lead", exact: true, strict: true, element: <Lead /> },
              {
                path: "lead-reject-reason",
                exact: true,
                strict: true,
                element: <LeadRejectReason />
              },
              {
                path: "welcome-kit",
                exact: true,
                strict: true,
                element: <WelcomeKit />
              },
              {
                path: "download-invoice",
                exact: true,
                strict: true,
                element: <DownloadInvoice />
              },
              loginUser?.is_subadmin == 0 && {
                path: "subadmin",
                exact: true,
                strict: true,
                element: <Subadmin />
              },
              {
                path: "training-webinar",
                exact: true,
                strict: true,
                element: <TrainingAndWebinar />
              },
              {
                path: "lvb-notification",
                exact: true,
                strict: true,
                element: <Notification />
              },
              { path: "poll", exact: true, strict: true, element: <Poll /> },
              {
                path: "description-edit",
                exact: true,
                strict: true,
                element: <DescriptionEdit />
              },
              {
                path: "member",
                exact: true,
                strict: true,
                element: <Member />
              },
              {
                path: "member-deactivate-reason",
                exact: true,
                strict: true,
                element: <MemberDeactivateReason />
              },
              {
                path: "cancel-membership-subject",
                exact: true,
                strict: true,
                element: <CancelMembershipSubject />
              },
              {
                path: "cancel-membership-request",
                exact: true,
                strict: true,
                element: <CancelMembershipRequest />
              },
              {
                path: "membership-flow",
                exact: true,
                strict: true,
                element: <MembershipFlow />
              },
              {
                path: "magazine",
                exact: true,
                strict: true,
                element: <Magazine />
              },
              {
                path: "lvb-suggestion",
                exact: true,
                strict: true,
                element: <Suggestion />
              },
              {
                path: "lvb-session-podcast",
                exact: true,
                strict: true,
                element: <LvbSessionPodcast />
              },
              {
                path: "greeting",
                exact: true,
                strict: true,
                element: <Greeting />
              },
              {
                path: "promotion-reasons",
                exact: true,
                strict: true,
                element: <AskReasons />
              },
              {
                path: "promotion",
                exact: true,
                strict: true,
                element: <Asks />
              },
              {
                path: "how-to-use-application",
                exact: true,
                strict: true,
                element: <HowToUseApplicationView />
              },
              {
                path: "invoice-setting",
                exact: true,
                strict: true,
                element: <InvoiceSetting />
              },
              {
                path: "lvb-promocode",
                exact: true,
                strict: true,
                element: <Promocode />
              },
              // loginUser.u_type == 3 && {
              //   path: "staff",
              //   exact: true,
              //   strict: true,
              //   element: <Staff />
              // },
              {
                path: "lvb-promocode-member-list",
                exact: true,
                strict: true,
                element: <PromocodeMemberList />
              },
              {
                path: "country",
                exact: true,
                strict: true,
                element: <Country />
              },
              { path: "state", exact: true, strict: true, element: <State /> },
              { path: "city", exact: true, strict: true, element: <City /> },
              {
                path: "referral-withdrawal-requests",
                exact: true,
                strict: true,
                element: <ReferralWithdrawalRequests />
              },
              {
                path: "referral-report",
                exact: true,
                strict: true,
                element: <ReferralReportList />
              },
              {
                path: "referral-report/:m_id",
                exact: true,
                strict: true,
                element: <ReferralReportDetail />
              }
            ]
          : // Normal USer
            [
              {
                path: "*",
                exact: true,
                strict: true,
                element: <DashboardApp />
              },
              {
                path: "dashboard",
                exact: true,
                strict: true,
                element: <DashboardApp />
              },
              { path: "lead", exact: true, strict: true, element: <Lead /> }
            ]
    }
  ]);
}
